import styled from 'styled-components';

export const ModalContent = styled.div`
  max-height: 70vh;
  overflow-y: auto;

  @media print {
    overflow: visible;
    max-height: none;
  }
`;

export const PrintableArea = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  line-height: 1.5;
  color: #333;

  @media screen {
    max-width: 21cm;
    margin: 0 auto;
  }

  @media print {
    width: 21cm;
    min-height: 29.7cm;
    padding: 0px 0px;
    margin: 0 auto;
  }

  .left-align {
    text-align: left;
  }

  .right-align {
    text-align: right;
  }

  .center-align {
    text-align: center;
  }

  .bordered {
    border: 1px solid #000000;
  }
`;

export const Header = styled.div`
  padding: 30px 0 20px 0;
  overflow: auto;
  width: 100%;
  line-height: 3px;
  font-weight: 600;
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
`;

export const CompanyInfo = styled.div`
  line-height: 1.5;
  flex: 3;

  p {
    margin: 0;
  }
`;

export const ReportInfo = styled.div`
  flex: 1;
  text-align: right;
  line-height: 1.5;

  p {
    margin: 0;
    line-height: 1.5;
  }
`;

export const Logo = styled.img`
  width: 110px;
`;

export const Title = styled.h2`
  text-align: center;
  margin-top: 10px;
  font-weight: bold;
`;

export const CostCenter = styled.div`
  border: 1px solid #000000;
  border-radius: 5px;

  &:nth-child(n + 2) {
    margin: 20px 0;
  }
`;

export const CostCenterHeader = styled.div`
  border-radius: 5px;
  background: #e2e2e2;
  padding: 5px 15px;

  h2 {
    margin: 0;
  }
`;

export const PaymentStatement = styled.div`
  margin-bottom: 10px;
  page-break-inside: avoid;
`;

export const InformacoesDemonstrativo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
  border: 1px solid #000000;
  background-color: #e2e2e2;
  border-right: none;
  border-left: none;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.span`
  font-weight: bold;
`;

export const Value = styled.span`
  margin-top: 2px;
  margin-left: 2px;
`;

export const TabelaLancamentos = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  thead {
    border-bottom: 1px solid #000000;
  }

  tr {
    margin: 0 5px;
  }
`;

export const TabelaAtosCooperativos = styled.table`
  width: 55%;
  border-collapse: collapse;
`;

export const TotalCentroCustoWrapper = styled.div`
  border-top: 1px solid #000000;
  page-break-inside: avoid;
`;

export const LancamentosTotalGeral = styled.div`
  display: flex;
  gap: 20px;
`;

export const LancamentosTotalGeralItem = styled.div`
  flex: 1;
  padding-left: 20px;
  padding-right: 20px;
`;

export const LancamentosTotalGeralDivider = styled.div`
  width: 1px;
  background-color: black;
`;

export const Totais = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 20px;
`;

export const Total = styled.div`
  flex: 0 0 calc(33.333% - 10px);
  text-align: left;
  white-space: nowrap;
`;

export const TabelaTotalGeral = styled.table`
  width: 50%;
  padding-left: 20px;
  padding-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;

  @media print {
    display: none;
  }
`;

export const NoDataMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #8c8c8c;
  font-size: 14px;
`;
